import { render } from "./footer.vue?vue&type=template&id=76476b00&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "../styles/homescreen.css?vue&type=style&index=0&id=76476b00&scoped=true&lang=css"
import "../styles/startmenu.css?vue&type=style&index=1&id=76476b00&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76476b00"]])

export default __exports__